$(() => {
  if (isProduction) { //只在正式环境禁止页面复制
    $('body').on('contextmenu', (event) => {
      event.preventDefault();
    }).on('selectstart', (event) => {
      event.preventDefault();
    });
  }
});
